import * as types from '../constants/actionTypes';
import * as Rx from 'rxjs';
const {
  Observable
} = Rx;
const { of, ajax
} = Observable;
import * as actions from '../actions/techInventoryActions';
const apiUrls = require('../constants/apiUrls');
import * as mouseFlowUtils from '../utils/mouseFlowUtils';
import {
  TAG_GET_TECH_INVENTORY
} from '../constants/mouseFlow';
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {
  getTechInventory: (request, userId, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    let url = apiUrls.TECH_GET_INVENTORY_URL;
    if (request && !request.isSelf) {
      url = `${apiUrls.TECH_GET_INVENTORY_URL}/byuserID?userID=${userId}`;
    }

    mouseFlowUtils.setNewPageView(url);
    mouseFlowUtils.setTag(TAG_GET_TECH_INVENTORY);

    return ajax({
      url: url,
      method: 'get',
      responseType: '',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  },
  searchInventory: (request, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = `${apiUrls.TECH_SEARCH_INVENTORY_URL}?SerialNumberOrMacAddress=${request.search}`;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: url,
      method: 'get',
      responseType: '',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  },
  transferTechEquipment: (request, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.TECH_TRANSFER_INVENTORY_URL,
      method: 'POST',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + accessToken,
        'Accept': 'application/json'
      }
    });
  }
};

export const getTechInventoryEpic = (action$, store, call = indirect.call) => {

  return action$
    .filter(action => {
      return action.type === types.TECH_INVENTORY_GET_STARTED || action.type === types.OUTLET_UPDATE_FINISHED;
    })
    .mergeMap(action => call(api.getTechInventory, action.request, action.userId, store).map((payload) => {
      let result = {};
      if (payload.response) {
        result = JSON.parse(payload.response);
      }
      return (actions.getTechInventoryFinished(result, action.userId, action.timestamp));

    }).takeUntil(action$.ofType(types.TECH_INVENTORY_GET_STARTED))
      .catch(error => of(actions.getTechInventoryFailed(error, action.userId, action.timestamp))));
};

export const searchForInventoryEpic = (action$, store, call = indirect.call) => {

  return action$
    .ofType(types.INVENTORY_SEARCH_STARTED)
    .mergeMap(action => call(api.searchInventory, action.request, store).map((payload) => {
      let result = {};
      if (payload.response) {
        result = JSON.parse(payload.response);
      }
      return (actions.searchInventoryFinished(result));

    }).takeUntil(action$.ofType(types.INVENTORY_SEARCH_STARTED))
      .catch(error => of(actions.searchInventoryFailed(error))));
};

export const transferTechEquipmentEpic = (action$, store, call = indirect.call) => {

  return action$
    .ofType(types.INVENTORY_TRANSFER_STARTED)
    .mergeMap(action => call(api.transferTechEquipment, action.request, store)
      .map((payload) => {
        let result = {};
        if (payload.response) {
          result = payload.response;
        }
        return (actions.transferInventoryFinished(result));
      }).takeUntil(action$.ofType(types.INVENTORY_TRANSFER_STARTED))
      .catch(error => of(actions.transferInventoryFailed(error))));
};



// WEBPACK FOOTER //
// ./src/epics/techInventoryEpics.js